export function getQuestIntroByCode(code) {
  return questIntroDataMap[code] || null;
}

export function parseQuestNameByCode(code) {
  return questNameMap[code] || '其他';
}

export function isNotNull(value) {
  return value !== null && value !== undefined;
}

const hollandQuestIntro = '你了解自己的职业兴趣吗？是否清楚自己适合怎样的工作环境？是否担心选择了一个不适合自己的职业？如果你对以上问题感到困惑，不妨做下这个测评。本测评能够帮助你发现自己的职业兴趣和优势，指引你找到更加适合自己的职业领域。'
const mbtiQuestIntro = '性格决定命运。我们当前的生活是与世界互动、与人际互动、与问题互动的结果，是过去采取或者不采取行动的结果。本测评旨在帮助你了解自己的性格特征，从而：更好地认识、接纳和欣赏自己；选择适合自己风格和特点的职业；理解自己与他人相处模式，更好地与他人相处和合作。'
const occvalueQuestIntro = '你在选择职业的时候是否感到迷茫？你知道自己最想从工作中获得什么吗？怎样的工作能够让你感到满意、充实？本测评可以帮助你看到“内心的声音”，发现你深层次的职业需求，从而更好地定位自己的发展方向和职业目标。'
const cddqQuestIntro = '选择比努力更重要。“职业选择”这个重大决策，可能决定了我们今后的生涯发展和人生轨迹。在职业选择过程中，“纠结体”、“选择困难症”是否在你身上出现过？你知道症结在哪吗？本测评可以帮助你发现影响自己做出良好生涯决策的症结，从而对症下药。'
const selfidQuestIntro = '我们都希望做自己，成为更好的自己。但做到这些的前提是，知道“我是谁”。否则我们做的可能是别人期待的/社会文化期待的应该成为的样子。你目前找到自己了吗？清楚地知道“我是谁”吗？通过测评来梳理一下吧。'
const univadaptQuestIntro = '进入大学是一个全新的经历，充满新奇和无限可能，同时也伴随着各种压力和挑战。当前你是否已经完全适应了大学生活？或者仍在适应的过程中？你是否遇到了一些困难和疑惑？通过测评来梳理下自己对于大学生活的适应状态吧。'
const dbassessQuestIntro = '每个人在成长过程中，都会形成一些关于职业选择、生涯发展方面的想法和信念，它们会以积极或消极的方式影响我们的生涯选择和生涯行动。测评可以帮助你了解自己的这些想法和信念，并发现那些可能会对你的生涯决策造成困扰的想法，从而针对性地进行改变。'
const cvcheckQuestIntro = '你写过简历吗？知道一份好的简历是怎样的吗？你认为自己的简历能够脱颖而出吗？知道好的简历的标准，是写出好的简历的前提。简历诊断测评评估了你对好的简历标准的了解程度，帮助你发现自己的认知短板，从而针对性地进行提升，以为撰写/优化简历做好准备。'
const discQuestIntro = '你了解自己的行事风格吗？知道自己个性上的优势和劣势吗？在什么样的环境下容易和人发生冲突？和什么样的队友合作，更能够达成任务目标？本测评将帮助你深入了解自己的个性特点以及如何与他人更有效地沟通和互动。'
const enneaQuestIntro = '我们都知道有十二个星座，但你知道吗，人格或者说性格也可以分为九种类型，我们每个人都倾向于其中一种类型。找到自己在人格“星图”上的位置，可以帮助我们发现自己最核心、最根本的需求和渴望，深层次的了解自己。'
const bstyleQuestIntro = '每个人都有独特而稳定的风格。例如，林黛玉多愁善感，关公勇猛忠诚。你的行为风格是怎样的？你在压力/逆境下是如何感受和思考的？你通常是如何和他人、环境互动的？通过测评，来解锁自己的风格特点吧。'
const pnascaleQuestIntro = '对于就业这件事，你是否清楚应该做哪些准备？你准备得如何了？想到就业，你内心产生了哪些情绪？情绪往往反映了你内心的需求、愿望、就业准备状态。本测评可以帮助你梳理自己在就业过程中的情绪状态，以更好地调控情绪、发现并解决就业过程中存在的问题。'
const deciseQuestIntro = '充足的信心是做出好的职业选择的基石。你对自己的职业决策能力有信心吗？知道决策能力分为哪些关键技能吗？你在哪方面的信心比较低？如何提高决策能力和信心呢？通过测评来寻找答案吧。'
const ceshiQuestIntro = '测试说明'
const holland56QuestIntro = '你了解自己的职业兴趣吗？是否清楚自己适合怎样的工作环境？是否担心选择了一个不适合自己的职业？如果你对以上问题感到困惑，不妨做下这个测评。本测评能够帮助你发现自己的职业兴趣和优势，指引你找到更加适合自己的职业领域。'



const questIntroDataMap = {
  'holland': hollandQuestIntro,
  'mbti': mbtiQuestIntro,
  'mbti70': mbtiQuestIntro,
  'occvalue': occvalueQuestIntro,
  'cddq': cddqQuestIntro,
  'selfid': selfidQuestIntro,
  'univadapt': univadaptQuestIntro,
  'dbassess': dbassessQuestIntro,
  'cvcheck': cvcheckQuestIntro,
  'disc': discQuestIntro,
  'ennea': enneaQuestIntro,
  'bstyle': bstyleQuestIntro,
  'pnascale': pnascaleQuestIntro,
  'decise': deciseQuestIntro,
  'ceshi': ceshiQuestIntro,
  'holland56':holland56QuestIntro
}


const questNameMap = {
  'holland': '霍兰德职业兴趣测评',
  'mbti': 'MBTI性格类型测评',
  'mbti70': 'MBTI性格类型测评(70题版)',
  'occvalue': '职业价值观',
  'cddq': '生涯决策困难诊断',
  'selfid': '自我认同',
  'univadapt': '大学适应性',
  'dbassess': '生涯信念',
  'cvcheck': '简历诊断',
  'disc': 'DISC',
  'ennea': '九型人格',
  'bstyle': '行为风格',
  'pnascale': '就业情绪识别量表',
  'decise': '职业决策效能感',
  'holland56': '霍兰德职业兴趣测评(57题版)'
}



